import React from 'react'
import * as FaIcons from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import { SidebarData } from './SidebarData'
import { IconContext } from 'react-icons'
import './ExamSidebar.css'

export const Sidebar = () => {
  const navigate = useNavigate()
  // logout function/clear local storage
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <nav className="nav-menu examNav">
          <ul className="nav-menu-items">
            <li className="navbar-toggle">
              <span style={{ marginLeft: '1rem' }} className="header-text">
                Inferenz
              </span>
              <FaIcons.FaBars
                style={{
                  marginRight: '2rem',
                  marginTop: '0.5rem',
                }}
              />
            </li>
            {/* mapping the sidebar data */}
            {SidebarData.map((item, index) => {
              return (
                <li
                  key={index}
                  className={item.cName}
                  //to trigger modal for logout confirmation
                  data-bs-target={
                    item.title === 'Logout' ? '#exampleModal' : ''
                  }
                  data-bs-toggle={item.title === 'Logout' ? 'modal' : ''}
                >
                  <Link
                    to={item.path}
                    id={
                      window.location.pathname === item.path ? 'activePath' : ''
                    }
                  >
                    <span className="sideIcon">{item.icon}</span>
                    <span style={{ marginLeft: '1rem' }}>{item.title}</span>
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
      </IconContext.Provider>

      {/* modal : confirmation for logout */}
      <div
        className="modal"
        tabIndex="-1"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to Logout from Intranet ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  logout()
                }}
                data-bs-dismiss="modal"
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
